module.exports = __webpack_public_path__ + "static/media/logo.bce99fc5.png";